module.exports = __webpack_public_path__ + "static/img/lingshishifen.01a97be.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lingshishifen.png
// module id = /Bqf
// module chunks = 2